var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnquireFrom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8165 44L25.5366 41.7201L34.2083 33.0483L33.0277 31.8677L24.3559 40.5394L22.076 38.2595L30.7478 29.5878L29.6078 28.4478L20.9361 37.1196L18.6562 34.8397L27.2872 26.1272L26.1065 24.9873L17.4348 33.659L15.1549 31.3791L25.3737 21.1196L33.8012 29.5471L38.4017 24.9466L28.7936 15.3384L32.132 12L45.9742 25.8422L27.8165 44ZM13.8521 30.3206L9.33301 25.8015L23.1345 12L36.0811 24.9466L33.7605 27.2672L25.333 18.8397L13.8521 30.3206Z",
    fill: "#20566B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquireFrom2);
export default __webpack_public_path__ + "static/media/enquireFrom2.4031ececd76e94a86a4d446ddf39a1da.svg";
export { ForwardRef as ReactComponent };